exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table[data-v-441c18b0] {\n  margin-bottom: 0 !important;\n}\n.paginator[data-v-441c18b0] {\n  margin-left: 2rem;\n}\n.filters[data-v-441c18b0] {\n  display: inline-block;\n  margin: 1rem 0 0 1rem;\n}\ntable th.compact[data-v-441c18b0], table td.compact[data-v-441c18b0] {\n  white-space: nowrap;\n  width: 1px !important;\n}\n", ""]);

// exports
